import Tooltip from "@mui/material/Tooltip";

interface Props {
  title: string;
  cutoff: number;
}

export default function LongText({ title, cutoff }: Props) {
  return (
    <Tooltip title={title}>
      <div>
        {title.length < cutoff || title.length === cutoff
          ? title
          : title.slice(0, cutoff) + "..."}
      </div>
    </Tooltip>
  );
}
